import React, { useEffect } from "react";
import { useField } from "formik";
import { Form } from "react-bootstrap";

interface InputTextProps {
  name: string;
  placeholder?: string;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel" | "url" | "date";
  className?: string;
  autocomplete?: string;
  required?: boolean;
  handleChange?: (value: string) => void;
  rightIcon?: React.ReactElement;
  style?: React.CSSProperties;
  min?: number;
  max?: number;
  step?: number;
}

const InputText: React.FC<InputTextProps> = ({
  name,
  placeholder = "",
  disabled = false,
  type = "text",
  className = "",
  autocomplete = "new-password",
  required,
  handleChange,
  rightIcon,
  style,
  min,
  max,
  step,
}) => {
  const [field, meta] = useField(name);

  useEffect(() => {
    handleChange?.(field.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field.value]);

  let formGroupClass = "";
  if (meta && meta.touched) {
    if (meta.error) {
      formGroupClass = "is-invalid";
    } else {
      formGroupClass = "is-valid";
    }
  }

  return (
    <div className={`position-relative ${rightIcon ? "input-custom" : ""}`}>
      <Form.Control
        className={`${className} ${formGroupClass}`}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        {...field}
        value={field.value || ""}
        autoComplete={autocomplete}
        required={required}
        min={min}
        max={max}
        step={step}
        style={{ position: "relative", ...style }}
      />
      {rightIcon && <span className="right-input-icon">{rightIcon}</span>}
      <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
    </div>
  );
};

export default InputText;
